import { FoodsIcon, HelperBox } from "@foodpilot/foods";
import { Stack, Box, Typography, useTheme } from "@mui/material";
import { useTranslation } from "react-i18next";

type Props = {
    parentName: string | undefined;
    propertyName: string | undefined;
    hasMultipleActions: boolean;
    propertiesWithMultipleActions: string[];
    position: number;
};
export const TableBlockHeader = (props: Props) => {
    const { hasMultipleActions, parentName, position, propertiesWithMultipleActions, propertyName } = props;

    const { t } = useTranslation();
    const theme = useTheme();
    return (
        <Stack
            gap={theme.spacing(2)}
            sx={{
                padding: theme.spacing(2),
            }}
        >
            <Box display="inline" sx={{ svg: { verticalAlign: "middle" } }}>
                {parentName !== undefined && (
                    <>
                        <Typography component="span" variant="body2">
                            {parentName}
                        </Typography>
                        <FoodsIcon size={2} icon="arrowRightShort" />
                    </>
                )}

                <Typography component="span" variant="h6">
                    {propertyName !== undefined ?
                        propertyName
                    :   t("action_plan.line.position", {
                            defaultValue: "Line {{position}}",
                            position: position + 1,
                        })
                    }
                </Typography>
            </Box>
            {hasMultipleActions && (
                <HelperBox>
                    <Typography variant="body2">
                        {t("action_plan.action.other_actions_impact_indicator", {
                            defaultValue:
                                "Other actions already taken also affect the indicator '{{propertyTitle}}'. You can find the details of their respective impacts in the table below.",
                            propertyTitle: propertiesWithMultipleActions.join(","),
                        })}
                    </Typography>
                </HelperBox>
            )}
        </Stack>
    );
};
